import { useEffect } from 'react';
import { useProfileQuery } from '@/models/user';
import { NAVIGATION_PATH } from '@/features/navigation/constants';
import { useNavigate } from 'react-router';

export const RootRedirect = () => {
  const { data } = useProfileQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (data) {
      navigate(NAVIGATION_PATH[data.role], { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  }, [data, navigate]);

  return null;
};
